export default __webpack_public_path__ + "static/media/Francais.4690dc14.png";